"use strict";
export const isHTMLElement = (element) => element.innerText !== void 0;
export default {
  isHTMLElement
};
